// third-party
import { FormattedMessage } from 'react-intl';
import { getUserRegionFromStorage, retrieveEncryptedData } from '../Application/utils/AppSessionStorage';

// assets
import {
    IconDashboard,
    IconDeviceAnalytics,
    IconPencilPlus,
    IconFileCheck,
    IconFileX,
    IconFileInfo,
    IconFileXFilled,
    IconPlane,
    IconUserCog,
    IconHelpHexagon,
    IconSettings
} from '@tabler/icons-react';

const icons = {
    IconDashboard: IconDashboard,
    IconDeviceAnalytics: IconDeviceAnalytics,
    IconPencilPlus: IconPencilPlus,
    IconFileCheck: IconFileCheck,
    IconFileX: IconFileX,
    IconFileInfo: IconFileInfo,
    IconFileXFilled: IconFileXFilled,
    IconPlane: IconPlane,
    IconUserCog: IconUserCog,
    IconHelpHexagon: IconHelpHexagon,
    IconSettings: IconSettings
};

// Retrieve the role from session storage
const roleName = retrieveEncryptedData();

// Conditionally set titles based on the role
const dashboardTitle =
    roleName === 'ROLE_AGENCY_ADMIN' ? (
        <FormattedMessage id="Agency Admin" />
    ) : roleName === 'ROLE_AGENT' ? (
        <FormattedMessage id="Agency User" />
    ) : roleName === 'ROLE_UNDER_WRITER' ? (
        <FormattedMessage id="Underwriter" />
    ) : (
        <FormattedMessage id="Dashboard" />
    ); // Default fallback title

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

// Country-based menu item configuration
const countryMenuItems = {
    Kenya: {
        id: 'generateQuoteKenya',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/agency/travel-portal/generate-quote',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    },
    Rwanda: {
        id: 'generateQuoteRwanda',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/agency/travel-portal/generate-quote-rw',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    }
};
const userCountry = (getUserRegionFromStorage() ?? 'Kenya') as keyof typeof countryMenuItems;
const selectedCountryItem = countryMenuItems[userCountry];

export const dashboard = {
    id: 'dashboard',
    title: dashboardTitle,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'default',
            title: <FormattedMessage id="Home" />,
            type: 'item',
            url: '/agency/home',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const travelInsurance = {
    id: 'travelInsurance',
    title: <FormattedMessage id="International Travel Insurance" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        selectedCountryItem, // Dynamically select based on userCountry

        {
            id: 'Completed Transactions',
            title: <FormattedMessage id="Completed Transactions" />,
            type: 'item',
            url: '/agency/travel-portal/completed-transactions',
            icon: icons.IconFileCheck,
            breadcrumbs: false
        },
        {
            id: 'Generated Quotes',
            title: <FormattedMessage id="Generated Quotes" />,
            type: 'item',
            url: '/agency/travel-portal/generated-quotes',
            icon: icons.IconFileX,
            breadcrumbs: false
        }
        // {
        //     id: 'travelPlans',
        //     title: <FormattedMessage id="Travel Plans" />,
        //     type: 'item',
        //     url: '/agency/travel-portal/travel-plans',
        //     icon: icons.IconPlane,
        //     breadcrumbs: false
        // }
    ]
};

export const agencyDetails = {
    id: 'agency',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'local-travels',
            title: <FormattedMessage id="Local Travels" />,
            type: 'item',
            url: '/agency/local-travels',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const users = {
    id: 'users',
    title: <FormattedMessage id="Users" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'usermanagement',
            title: <FormattedMessage id="User Management" />,
            type: 'item',
            url: '/agency/user-management',
            icon: icons.IconUserCog,
            breadcrumbs: false
        }
    ]
};

export const support = {
    id: 'support',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        // {
        //     id: 'support',
        //     title: <FormattedMessage id="Support" />,
        //     type: 'item',
        //     url: '/agency/support',
        //     icon: icons.IconHelpHexagon,
        //     breadcrumbs: false
        // },
        {
            id: 'Settings',
            title: <FormattedMessage id="Settings" />,
            type: 'item',
            url: '/agency/settings',
            icon: icons.IconSettings,
            breadcrumbs: false
        }
    ]
};
